<template>
    <!-- 알림 설정 -->
  <div class="card onmaum-w-100">
    <div class="card-header">알림 설정</div>
    <div class="card-body">
        <label class="form-control-label">알림 권한 요청</label>
        <div class="row text-center">
            <div class="col-md-3 col-12 mt-1">
                <button id="alarm" class="btn" :class="alarmClass" @click="setNotification()">{{alarmBtnText}}</button>
            </div>
            <div class="col-md-9 col-12 mt-1">
                {{ msg }}
            </div>
            
        </div>
    </div>
  </div>

  <!-- 알림 보내기 -->
  <div class="card onmaum-w-100 mt-5">
    <div class="card-header">알림 보내기</div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-12 col-12">
                <label for="alarmTitle" class="form-control-label">제목</label>
                <input id="alarmTitle" class="form-control invalid" type="text" v-model="alarmTitle" placeholder="제목"/>
            </div>
            <div class="col-md-12 col-12">
                <label for="alarmContent" class="form-control-label">내용</label>
                <input id="alarmContent" class="form-control invalid" type="text" v-model="alarmContent" placeholder="내용"/>
            </div>
            <div class="col-md-12 col-12">
                <button class="btn btn-onmaum text-sm" @click="sendPush()">알림 발송</button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
    name: 'AlarmManage',
    data(){
        return {
            alarmClass: '',
            alarmBtnText: '',
            msg: '',

            alarmTitle: '',
            alarmContent: '',
        }
    },

    watch: {

    },

    methods: {
        // 알림 권한 요청
        setNotification(){
            Notification.requestPermission().then(permission => {
                if (permission === "granted") {
                    this.setAlarmBtn(1);
                }else if(permission === 'denied'){
                    this.setAlarmBtn(2);
                }
            });
        },

        // 권한에 따른 버튼 및 설명 변경
        setAlarmBtn(id){
            switch(id){
                case 1: // 허용
                    $('#alarm').prop('disabled', true);
                    this.alarmBtnText = '허용됨';
                    this.alarmClass = 'btn-primary text-white';
                    this.msg = '알림이 허용되어 있습니다. 알림을 받지 않으려면 브라우저의 알림 권한을 설정해주세요.';

                    // Serviceworker의 pushManager Subscription 갱신
                    this.configureAlarm();

                    break;
                case 2: // 거부
                    $('#alarm').prop('disabled', true);
                    this.alarmBtnText = '거부됨';
                    this.alarmClass = 'btn-danger text-white';
                    this.msg = '알림이 차단되어 있습니다. 알림을 받으시려면 브라우저의 알림 권한을 설정해주세요.';
                    break;
                case 3: // 미설정
                    $('#alarm').prop('disabled', false);
                    this.alarmBtnText = '알림권한요청';
                    this.alarmClass = 'btn-onmaum';
                    this.msg = `알림 권한 설정이 안 돼 있습니다. 알림을 받으시려면 '알림권한요청' 버튼을 누른 후, 브라우저 알림 권한 요청창이 뜨면 '허용'을 눌러주세요.`
                    break;
                case 4: // 미지원
                    $('#alarm').prop('disabled', true);
                    this.alarmBtnText = '미지원';
                    this.alarmClass = 'btn-secondary text-white';
                    this.msg = `알림 기능을 제공하지 않는 브라우저입니다. 알림 권한을 사용하시려면 다른 브라우저(예. Chrome)를 이용해주세요.`;
                    break;
                default: // 기본은 '미설정'
                    $('#alarm').prop('disabled', false);
                    this.alarmBtnText = '알림권한요청';
                    this.alarmClass = 'btn-onmaum';
                    this.msg = `알림 권한 설정이 안 돼 있습니다. 알림을 받으시려면 '알림권한요청' 버튼을 누른 후, 브라우저 알림 권한 요청창이 뜨면 '허용'을 눌러주세요.`
                    break;
            }

            
        },

        // 알림 구독 설정
        configureAlarm(){
            if(!('serviceWorker' in navigator)){
                console.log('서비스 워커가 없습니다.');
                return;
            }

            navigator.serviceWorker.ready
            .then(sw => {
                return sw.pushManager.getSubscription();
            })
            .then(sub => {
                if(sub === null){
                    this.newSubscription();
                }else{
                    console.log('이미 구독되어 있습니다.');
                }
            });
        },

        // 서비스워커에 구독 정보 없는 경우 구독 정보 서비스 워커에 저장 및 DB 저장
        newSubscription(){
            navigator.serviceWorker.ready
            .then(sw => {
                const vapidPubKey = 'BOphx6ruCbNRiLMgyPj0WwuquuGOFT4bbTH8BT-eCE4RumTtyVDT87euekWUaQJVxIhKMY4gz5nIJbuhTpkeC6Q';
                const convVapidPubKey = this.urlB64ToUint8Array(vapidPubKey);

                return sw.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: convVapidPubKey
                })
                .then(newSub => {
                    const tempSub = JSON.parse(JSON.stringify(newSub));

                    console.log(`tempSub: ${tempSub}`);

                    let pushConfig = {
                        endpoint: tempSub.endpoint,
                        keys: {
                            p256dh: tempSub.keys.p256dh,
                            auth: tempSub.keys.auth
                        }
                    };

                    // DB 저장
                    this.$store.dispatch('insertSubscribe', pushConfig);

                    this.welcomeNotification();
                })
            });
        },

        // 구독 해지(현재 미사용)
        unSubscription(){
            navigator.serviceWorker.ready
            .then(sw => {
                return sw.pushManager.getSubscription();
            })
            .then(oldSub => {
                oldSub.unsubscribe();
            })
            .catch(err => {
                console.log(err);
            })
        },

        // base64 => array 변환
        urlB64ToUint8Array(base64String) {
            const padding = '='.repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');

            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);
        
            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        },

        // 최초 알림 구독 시 환영 안내 알림
        welcomeNotification() {
            const notification = new Notification("환영합니다!", {
                body: "[온마음-관리자] 늘 On 되어있습니다. 고객 중심적인 사고와 합리적인 상품, 지속적 관리로 서로 상생합니다.",
                icon: "/img/icons/onmaum-512x512.png",
                //badge: "",
                //image: "",
                //actions: [],
                vibrate: [500, 100, 500]
            });
            
            // 알림 클릭 시 실행할 동작 설정
            notification.onclick = () => {
                console.log("Alarm Clicked!");
            };
        },

        // 알림 보내기
        sendPush(){
            new Notification(this.alarmTitle, {
                body: this.alarmContent,
                icon: "/img/icons/onmaum-512x512.png",
                //badge: "",
                //image: "",
                //actions: [],
                vibrate: [500, 100, 500]
            });

            // const alarmData = JSON.stringify({
            //     title: this.alarmTitle,
            //     content: this.alarmContent
            // });

            // fetch('', {
            //     method: "POST",
            //     headers: {
            //         'Content-type': 'application/json'
            //     },
            //     body: alarmData
            // })
            // .catch((error) => {
            //     console.log(error);
            // })
        },
    },

    mounted(){
        if ("Notification" in window) {
            if (Notification.permission === "granted") {
                // 알림 권한이 이미 허용된 경우
                this.setAlarmBtn(1);
            } else if(Notification.permission === "denied") {
                // 알림이 차단된 경우, 알림 설정 기능 비활성화
                this.setAlarmBtn(2);
            } else if (Notification.permission !== "denied") {
                // 알림 권한에 대한 선택을 아직 하지 않은 경우 (permission === "default")
                this.setAlarmBtn(3);
            }
        } else {
            // 알림 기능 미지원
            this.setAlarmBtn(4);
        }

        this.welcomeNotification();
    }


}
</script>

<style>

</style>